import { LoadingOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import type React from 'react';
import { useState } from 'react';

import { IconMapping } from 'src/components/icons/icon-mapping/icon-mapping';
import { useGetMappingResultsData } from 'src/hooks/data/partner-games';
import { showMappingResultsNotification } from 'src/services/notify/notify';
import { LaunchMappingModal } from './launch-mapping-modal/launch-mapping-modal';

export const GlobalMappingLauncher: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { data, isInProgress } = useGetMappingResultsData();
  const isRunning = data?.status === 'running';

  if (isInProgress) {
    return null;
  }

  return (
    <>
      <div className="flex items-center gap-x-12">
        {!isRunning && (
          <Button type="primary" onClick={() => setIsOpen(true)}>
            Launch Global Mapping
          </Button>
        )}

        <div
          onClick={() => {
            if (data) {
              showMappingResultsNotification(data);
            }
          }}
          className="flex justify-center items-center text-gray-1 rounded bg-[#363636] size-32 relative cursor-pointer"
        >
          <IconMapping
            className="absolute-center duration-200"
            width={isRunning ? 16 : 24}
            height={isRunning ? 16 : 24}
          />
          {isRunning && <Spin indicator={<LoadingOutlined style={{ fontSize: 26 }} spin />} className="relative" />}
        </div>
      </div>

      <LaunchMappingModal isOpen={isOpen} close={() => setIsOpen(false)} />
    </>
  );
};
